<template>
<div class="page tableofcontents">
  <a name="approach"></a>
  <p class="preheader">
    Introduction
  </p>
  <p class="dustin-title ">
    Approach to Data
  </p>
  <p class="preheader ">
    Values Alignment Data
  </p>
  <p class="description">
    This report defines social and environmental impact as the tangible environmental and social effects of companies on the world. This report focuses on the social and environmental impact and alignment of a portfolio to a set of values selected for analysis.
  </p>
  <br>
  <p class="preheader">
    Data Gathering Philosophy
  </p>
  <div class="content description">
    <p>
      YourStake gathers data from publicly available sources and cites every data point to ensure verifiability. YourStake looks for data that meet the following criteria:
    </p>
    <ul>
      <li>Hosted by government, regulatory, academic, trusted NGO sources*, or company filings.</li>
      <li>Applies to a broad set of companies, either across a sector, geographical region, or the whole economy.</li>
      <li>Contains quantitative, comparable measures.</li>
      <li>Updated frequently to reflect the current state of the world.</li>
    </ul>
    <p>
      When possible, we choose not to gather data from voluntary company reporting because companies often use different methodologies to report similar metrics, leading to the inability to compare, or worse, misleading comparisons that are not apples-to-apples. Instead, by using third-party and standardized data sources, we can ensure fair comparability. YourStake frequently updates and improves our list of data sources.
    </p>
    <p>
      For portfolios containing mutual funds that conduct shareholder engagement, YourStake aggregates shareholder engagement success stories, drawing from company reporting, including fund manager impact reports, websites, press releases, blog posts, and the general news media.
    </p>
    <p>
      * We determine that a NGO source is a trusted source if it:
    </p>
    <ul>
      <li>Has a detailed and transparent methodology.</li>
      <li>Is updated frequently,</li>
      <li>Is already used by government regulators or the investor community to analyze, evaluate, or engage with companies.</li>
    </ul>
  </div>
  <section class="print-no-break">
    <p class="preheader">
      Approach to Data Gaps
    </p>
    <p class="description">
      When a company does not have information about a particular metric, YourStake.org does not attempt to estimate or interpolate coverage for the sake of increased coverage. YourStake only deals with reported data as it exists. All calculations are made based on the data that is available from the primary sources, not estimated data.
    </p>
  </section>
</div>
</template>


<script>

  export default {
    components: {
    },
    data () {
      return {
        datacollection: {}
      }
    },
    mounted () {
    },
  }

</script>

<style lang="css" scoped>
  .persona_vegan .icon {
    color: #5aa9e6;
  }
  .persona_environmentalist .icon {
    color: #93C48B;
  }
  .persona_racial_justice .icon {
    color: #685369;
  }
  .persona_feminist .icon {
    color: #f1ab86;
  }
  .persona_virtuous .icon {
    color: #78CAD2;
  }
  .persona_labor .icon {
    color: #A40E4C;
  }
  .persona_law_and_order .icon {
    color: #8499B1;
  }

  .additional-notes {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .additional-notes label, #notes-input {
    display: block;
    width: 75%;
    margin: 0 auto;
  }

  #notes-input {
    background-color: #fff;
    padding: 5px;
    height: 150px;
    margin: 15px auto;
    border: 2px solid lightgray;
  }

  .actions {
    text-align: center;
    margin: 0 auto;
  }

  .actions > a {
    display: block;
    margin-top: 20px;
  }

.moreshow {
  /* display: none */
}

</style>
